
export class CategoryUtils {
    static array_category = [
        'tech',
        'economy',
        'education',
        'lifestyle',
        'startup',
        'impact',
        'agenda',
        'bandi',
        'my',
        'unstoppablewomen',
        // 'default',
        'life',
        'valoreresponsabile',
        'smartmoney',
        'option',
        'about_us',
        'investor',
        // 'menu_desk_life',
        // 'menu_desk_valoreresponsabile',
        // 'menu_desk_smartmoney',
        // 'menu_desk_about_us',
        // 'menu_desk_investor',
        // 'menu_desk_rubrica0',
        'default',
    ]

    constructor(category = undefined) {
        if(category) this.category = category.toLowerCase().replace(/\//g, '');
        if(this.category === 'unstoppable-women') this.category = 'unstoppablewomen';
    }

    get verticals() {
        return [
            'life',
            'valoreresponsabile',
            'smartmoney',
        ]
    }

    get link() {
        // console.log('this.category', this.category);
        const link = CategoryUtils.array_category.includes(this.category) ? `/${this.category}` : `/category/${this.category}`

        return link
    }
};
